import React, { useState } from "react";

const Input = React.forwardRef(({
  label,
  type = "text",
  name,
  value,
  onChangeHandler,
  onFocusHandler,
  placeholder,
  disabled = false,
  required = false,
  maxLength,
  minLength,
  pattern,
  autoComplete = "off",
  error,
  className = "",
  id = "",
  ...rest
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  // Add a red border when input has error or when focused
  const inputClass = `
    form-control
    ${className}
    ${error ? "is-invalid" : ""}
    ${isFocused ? "input-focused" : ""}
  `.trim();

  return (
    <div className="form-group mb-3">
      {label && (
        <label htmlFor={id || name} className="mb-1 mt-1 text-capitalize fw-semibold">
          {label}
          {required && <i className="text-danger ms-1">*</i>}
        </label>
      )}

      <input
        type={type}
        name={name}
        id={id || name}
        // ✅ Only pass value if not a file input
        {...(type !== "file" ? { value } : {})}
        onChange={onChangeHandler}
        onFocus={(e) => {
          setIsFocused(true);
          if (typeof onFocusHandler === "function") onFocusHandler(e);
        }}
        onBlur={() => setIsFocused(false)}
        className={inputClass}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        minLength={minLength}
        pattern={pattern}
        autoComplete={autoComplete}
        aria-invalid={!!error}
        ref={ref}
        {...rest}
      />
      {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
    </div>
  );
});

export default Input;
